import { PageV2 } from 'ui/components'

import {
  Actions,
  BankAccounts,
  Footer,
  GeneralInformation,
  History,
  QuestionnaireForm,
  SideBar,
  UploadedFiles,
  Warnings
} from './components'
import { HRRContextProvider, useHRRContext } from './context'

const Details = () => {
  const { data } = useHRRContext()
  const { titleOverline, title } = data

  return (
    <PageV2 face="secondary" title={titleOverline} subTitle={title} actions={<Actions />} footer={<Footer />}>
      <HRRContextProvider>
        <SideBar />
        <Warnings />
        <GeneralInformation />
        <BankAccounts />
        <QuestionnaireForm />
        <UploadedFiles />
        <History />
      </HRRContextProvider>
    </PageV2>
  )
}

const DetailsWrapper = () => {
  return (
    <HRRContextProvider>
      <Details />
    </HRRContextProvider>
  )
}

export default DetailsWrapper
